export default __webpack_public_path__ + "apply13b61518.png";